export enum EInventoryItemStatus {
  AVAILABLE = 'AVAILABLE',
  SOLD_OUT = 'SOLD_OUT',
}



export default EInventoryItemStatus;
